var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-size-dialog" },
    [
      _c(
        "v-card",
        { staticClass: "fill-height", attrs: { outlined: "" } },
        [
          _c(
            "v-subheader",
            {
              staticClass:
                "title font-weight-light d-flex justify-space-between"
            },
            [
              _vm._v(
                " Ticket #" +
                  _vm._s(this.ticketDetail.id) +
                  " " +
                  _vm._s(_vm.customerDetail) +
                  " "
              ),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.closeAccessPermissionDetail(false)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [_c("PDTDescription")],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [_c("PDTFolks")],
                1
              ),
              _vm.ticketDetail.accessPermission.workflowAccessPermissionsStates
                .length
                ? _c("v-col", { attrs: { cols: "12" } }, [_c("PDTComments")], 1)
                : _vm._e()
            ],
            1
          ),
          _vm.IS_EMPLOYEE &&
          (_vm.CAN_APPROVE_ACCESS_PERMISSION ||
            _vm.CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL) &&
          _vm.ticketDetail.accessPermission.status.id !==
            _vm.notApprovedStatusId
            ? _c(
                "v-row",
                { staticClass: "pa-2 mx-4", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "end", align: "center" } },
                        [
                          _vm.CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL
                            ? _c("v-textarea", {
                                staticClass: "mt-3",
                                attrs: {
                                  outlined: "",
                                  counter: "65500",
                                  rows: "1",
                                  label: "Comentario sobre la aprobación",
                                  rules: [
                                    _vm.rules.fieldLength(65550),
                                    _vm.rules.specialCharacters()
                                  ]
                                },
                                model: {
                                  value: _vm.comment,
                                  callback: function($$v) {
                                    _vm.comment = $$v
                                  },
                                  expression: "comment"
                                }
                              })
                            : _vm._e(),
                          _vm.CAN_APPROVE_ACCESS_PERMISSION ||
                          _vm.CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "#2B953E", outlined: "" },
                                  on: { click: _vm.askForChange }
                                },
                                [_vm._v("SOLICITAR CAMBIOS")]
                              )
                            : _vm._e(),
                          _vm.CAN_APPROVE_ACCESS_PERMISSION ||
                          _vm.CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: {
                                    color: "#2B953E",
                                    outlined: "",
                                    loading: _vm.sendingNotApprovedReview
                                  },
                                  on: { click: _vm.reject }
                                },
                                [_vm._v("NO APROBAR")]
                              )
                            : _vm._e(),
                          _vm.CAN_APPROVE_ACCESS_PERMISSION ||
                          _vm.CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: {
                                    color: "#2B953E",
                                    dark: "",
                                    loading: _vm.sendingApprovedReview
                                  },
                                  on: { click: _vm.approve }
                                },
                                [_vm._v("APROBAR")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.IS_EMPLOYEE && _vm.workflowSteps.length > 0 && _vm.writeChange
            ? _c(
                "v-fade-transition",
                [
                  _c("PDTChangeCommentSection", {
                    on: { sendRequestForChange: _vm.sendRequestForChange }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", color: "success" },
          model: {
            value: _vm.successReview,
            callback: function($$v) {
              _vm.successReview = $$v
            },
            expression: "successReview"
          }
        },
        [
          _vm._v(
            " La revisión sobre el Permiso de Acceso fue realizada exitosamente "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  !_vm.successReview
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", color: "error" },
          model: {
            value: _vm.errorLoadingContent,
            callback: function($$v) {
              _vm.errorLoadingContent = $$v
            },
            expression: "errorLoadingContent"
          }
        },
        [
          _vm._v(
            " Ocurrió un error " +
              _vm._s(_vm.action) +
              " el Permiso de Acceso, por favor intente nuevamente "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  !_vm.errorLoadingContent
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }